import { Injectable } from '@angular/core';
import { SessionStorageService } from './session-storage.service';
import { ClientDetails, SessionStorage } from './constant.service';

@Injectable({
  providedIn: 'root'
})
export class UserSessionService {

  constructor(private sessionStorageService: SessionStorageService) {}

  getUserSessionData() {
    return {
      userEmail:
        this.sessionStorageService.getItem(SessionStorage.userEmail) || '',
      clientCode:
        this.sessionStorageService.getItem(SessionStorage.clientCode) || '',
      appSource:
        this.sessionStorageService.getItem(SessionStorage.appSource) || '',
      subSource:
        this.sessionStorageService.getItem(SessionStorage.subSource) || '',
      userMobile:
        this.sessionStorageService.getItem(SessionStorage.userMobile) || '',
      ip: this.sessionStorageService.getItem(SessionStorage.ip) || '',
      userName:
        this.sessionStorageService.getItem(SessionStorage.userName) || '',
    };
  }

  clearRollbackLocalStorage() {
    this.sessionStorageService.removeItem(ClientDetails.PanFirstName);
    this.sessionStorageService.removeItem(ClientDetails.PanLastName);
    this.sessionStorageService.removeItem(ClientDetails.PanMiddleName);
  }
}
